/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  HealthcareProvider,
  HealthcareProviderFromJSON,
  HealthcareProviderFromJSONTyped,
  HealthcareProviderToJSON,
} from "./";

/**
 *
 * @export
 * @interface HealthcareProviderControllerResponse
 */
export interface HealthcareProviderControllerResponse {
  /**
   *
   * @type {HealthcareProvider}
   * @memberof HealthcareProviderControllerResponse
   */
  data?: HealthcareProvider;
  /**
   *
   * @type {ErrorResponse}
   * @memberof HealthcareProviderControllerResponse
   */
  error?: ErrorResponse;
}

export function HealthcareProviderControllerResponseFromJSON(json: any): HealthcareProviderControllerResponse {
  return HealthcareProviderControllerResponseFromJSONTyped(json, false);
}

export function HealthcareProviderControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HealthcareProviderControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : HealthcareProviderFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function HealthcareProviderControllerResponseToJSON(value?: HealthcareProviderControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: HealthcareProviderToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
